import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-fixed-widgets',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fixed-widgets">
      <div
        class="mwc-avatar mwc-avatar-circle mwc-avatar-icon fixed-widgets-avatar"
        style="width: 44px; height: 44px; line-height: 44px; font-size: 22px;"
        mwc-dropdown
        mwcPlacement="topCenter"
        [mwcDropdownMenu]="menu"
      >
        <theming-icon></theming-icon>
        <mwc-dropdown-menu #menu="mwcDropdownMenu">
          <ul mwc-menu mwcSelectable>
            <li mwc-menu-item (click)="onThemeChange('default')">{{ language === 'zh' ? '默认主题' : 'Default' }}</li>
            <li mwc-menu-item (click)="onThemeChange('dark')">{{ language === 'zh' ? '暗黑主题' : 'Dark Theme' }}</li>
            <li mwc-menu-item (click)="onThemeChange('compact')">{{ language === 'zh' ? '紧凑主题' : 'Compact Theme' }}</li>
            <li mwc-menu-item (click)="onThemeChange('aliyun')">{{ language === 'zh' ? '阿里云主题' : 'Aliyun Theme' }}</li>
          </ul>
        </mwc-dropdown-menu>
      </div>
    </div>
  `
})
export class FixedWidgetsComponent {
  compact = false;
  @Input() theme: string = 'default';
  @Input() language: string = 'zh';
  @Output() readonly themeChange = new EventEmitter<string>();

  onThemeChange(theme: string): void {
    this.theme = theme;
    this.themeChange.emit(theme);
  }
}
